/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import PostControls from 'flarum/forum/utils/PostControls';
import type Post from 'flarum/common/models/Post';
import ReviewPage from '../components/ReviewPage';

/** The component owning the delete control; its loading flag is toggled around the request. */
interface DeleteContext {
	loading: boolean;
}

/**
 * PostControls, with deleteAction dropping the review from the list too.
 *
 * CORE_CODE_OVERRIDE
 */
export default {
	...PostControls,

	deleteAction(this: Post, context?: DeleteContext): Promise<void> | void {
		if (!confirm(extractText(app.translator.trans('core.forum.post_controls.delete_confirmation')))) return;
		if (context) context.loading = true;

		return this.delete()
			.then(() => {
				const discussion = this.discussion();

				discussion.removePost(this.id()!);

				// No posts left means the discussion went with it.
				if (!discussion.postIds().length) {
					app.reviews.removeDiscussion(discussion);

					// `ReviewPage`'s attr is the Discussion, not the Post.
					if (app.current.matches(ReviewPage, { discussion })) {
						app.history.back();
					}
				}
			})
			.catch(() => {})
			.then(() => {
				if (context) context.loading = false;
				m.redraw();
			});
	},
};
